<template>
  <div class="v-datatable v-table v-datatable--select-all">
    <div class="v-datatable__actions">
      <div class="v-datatable__actions__select">Rows per page: 
        <v-select class="" v-model="paginationOptions.rowsPerPage" :items="paginationOptions.perPageOptions"></v-select>
      </div>
      <div class="v-datatable__actions__range-controls">
        <div class="v-datatable__actions__pagination">{{itemsFrom}}-{{itemsTo}} of {{itemsCount}}</div>
        <v-btn flat icon :disabled="!hasPreviousPage" @click="loadPreviousPage">
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-btn flat icon :disabled="!hasNextPage" @click="loadNextPage">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Pagination',

    data () {
      return {
        
      }
    },

    created () {
      	
    },

    methods: {

      loadNextPage () {
        this.$store.commit('setPage', this.currentPage+1)
        this.$emit('loadPage')
      },

      loadPreviousPage () {
        this.$store.commit('setPage', this.currentPage-1)
        this.$emit('loadPage')
      }

    },

    mounted () {
    	this.$store.commit('setPage', 1)
      this.$emit('loadPage')
    },

    computed: {

      pages () {
        let pages = 0
        if (this.itemsCount) {
          pages = Math.ceil(this.itemsCount / this.paginationOptions.rowsPerPage)
        }
        return pages
      },
      
      hasPreviousPage () {
        return this.currentPage > 1
      },

      hasNextPage () {
        return this.currentPage < this.pages
      },

      itemsFrom () {
        return (( this.currentPage - 1 ) * this.paginationOptions.rowsPerPage ) + 1 
      },

      itemsTo () {
        let itemsTo = this.currentPage * this.paginationOptions.rowsPerPage

        if (itemsTo > this.itemsCount) {
          itemsTo = this.itemsCount
        }
        return itemsTo
      }

    },

    watch: {
      paginationOptions: {
        handler (val) {
          this.$store.commit('setPerPage', val.rowsPerPage)
          this.$store.commit('setPage', 1)
          this.$emit('loadPage')
        },
        deep: true
      }
    }
    
  }
</script>

<style scoped>

</style>
